import {IncomeEmail} from "@app/core-app/app/data/ses/income-email";
import logger from "@app/core-app/logger";

export const createInboxMessageFileKey = (id: string): string => {
  return "inbox/" + id
}


export const getNormalizedEmailRecipients = (email: IncomeEmail): string[] => {
  const recipients = email.recipients?.map((address) => {
    const left = address.indexOf("<")
    const right = address.indexOf(">")
    if (left > -1 && right > -1) {
      return address.slice(left + 1, right)
    } else {
      return address
    }
  }) || []

  const uniqueRecipients = Array.from(new Set(recipients))
  return uniqueRecipients
}

export const getSupportedEmailDomains = (): string[] => {
  return ["inbox.notionsender.com", "notionsender.com", "dev-inbox.notionsender.com"]
}


export const formatKeyToEmail = (key: string) => {
  return `${key}@notionsender.com`
}
export const findAllKeysInEmailRecipients = (recipients: string[]): string[] => {
  const supportedDomains = getSupportedEmailDomains()
  const keys = recipients
    .filter(r => {
      return supportedDomains.some((d) => r.includes(d))
    })
    .map(x => x.split("@")[0])

  return keys
}
